import { Firm } from '../../app/modules/chart/interface/interfaces';
import { ReduxAction, ReduxType } from '../interface';

const data: Firm = {
  firmId: -1,
  name: ''
};
export default (state: Firm, action: ReduxAction<Firm>) => {
  if (!state) {
    state = data;
  }
  if (action.type === ReduxType.SELECTED_APPLIANCE_ID) {
    return Object.assign({}, state, action.payload);
  } else {
    return state;
  }
};
